export function getDefaultStartTime() {
    let outDate = new XDate(new Date());
    return outDate.toString("yyyy-MM-dd");
}

export function getDefaultEndTime() {
    let outDate = new XDate(new Date());
    return outDate.addDays(1).toString("yyyy-MM-dd");
}

export function formatDate(date) {
    if (date === null) return;
    let outDate = new XDate(date);
    return outDate.toString("yyyy-MM-dd");
}

export function formatDates(date) {
    if (date === null) return;
    let outDate = new XDate(date);
    return outDate.toString("yyyy年MM月dd日");
}

export function formatDateTime(date) {
    let outDate = new XDate(date);
    return outDate.toString("yyyy-MM-dd HH:mm:ss");
}

export function formatDay(date) {
    let now = new Date().getDate()
    let dates = new Date(date).getDate()
    let day = dates - now
    if (day == 0) {
        day = 1
    }
    return day;
}